<template>
  <DBox
    :id="'cmp-dtplugins-dbox-files'"
    :addButton="false"
    :addLink="true"
    :addLinkLabel="$t('add_new_file')"
    @add_click="addFileClick"
  >
    <NTable
      class="invcoie-line-list dbox1"
      :headers="headers"
      :items="files"
      :config="tableConfig"
      :id="'dtplugins-dbox_files'"
      height="170px"
      :showNoItems="false"
    >
      <template v-slot:item="{ item, tdcon }">
        <tr>
          <td v-bind="tdcon('name')">
            <span
              ><a
                class="dt-button v3 ut-link ut-text-accent5"
                style="font-weight: inherit"
                :href="getFilePath(item)"
                target="_blank"
              >
                {{ getFileName(item) }}
              </a></span
            >
          </td>
          <td v-bind="tdcon('mail')">
            <div class="dt-icon-container">
              <img
                src="static/icons/email/email-grey.svg"
                class="dt-icon v5 s1"
                @click="(e) => onFileMail(item)"
                alt="Mail File"
                title="Mail File"
              />
            </div>
          </td>
          <td v-bind="tdcon('options')">
            <div class="dt-icon-container">
              <img
                src="static/icons/delete.svg"
                class="dt-icon v5 s1"
                @click="(e) => onFileDelete(item)"
                alt="Delete File"
                title="Delete File"
              />
            </div>
          </td>
        </tr>
      </template>
    </NTable>
    <!-- <div class="dt-list v2">
      <div
        class="dt-list-item"
        v-for="file of files"
        :key="file.file_relation_id"
      >
        <div class="dt-list-item--body">
          <div
            class="dt-list-item--text"
            :title="file.file_name"
            style="max-width: calc(100% - 87px)"
          >
            <a
              class="dt-button v3"
              :href="getFilePath(file)"
              target="_blank"
            >
              {{
                file.file_description
                  ? file.file_description
                  : file.file_name
                  ? file.file_name
                  : ""
              }}
            </a>
          </div>
          <div
            class="dt-list-item--icon"
            style="max-width: 30px; width: 30px"
          >
            <div class="dt-icon-container">
              <img
                src="static/icons/email/email-grey.svg"
                @click="(e) => onFileMail(file)"
                class="dt-icon v5 s1"
                alt="Mail"
                title="Mail"
              />
            </div>
          </div>
          <div
            class="dt-list-item--icon"
            style="max-width: 30px; width: 30px"
          >
            <div class="dt-icon-container">
              <img
                src="static/icons/delete.svg"
                @click="(e) => onFileDelete(file)"
                class="dt-icon v5 s1"
                alt="Delete File"
                title="Delete File"
              />
            </div>
          </div>
        </div>
      </div>
    </div> -->
  </DBox>
</template>

<script>
import {
  deleteFileFromArray,
  getFileAction,
  getFileConfig,
} from "../file-uploader/config";
import {
  clientName,
  baseUrl,
} from "../../services/http/http-client";
import { FileService } from "../file-uploader/file.service";
import { sendMail, sendMailHref } from "../../utility";
import DBox from "@dtplugins/dbox/dbox";
import NTable from "@/plugins/datatable/datatable";

import {
  createNTableConfig,
  createTableHeader,
} from "../../plugins/datatable";
import { confirmDelete } from "../confirmation/confirmation-common";

export default {
  components: {
    DBox,
    NTable,
  },
  props: {
    files: {
      type: Array,
      default: () => [],
    },
    externalId: {
      required: true,
    },
    externalTable: {
      required: true,
    },
  },
  data: function () {
    return {
      config: null,
      tableConfig: createNTableConfig({
        headerStyle: 3,
        fullHeight: true,
        showHeader: false,
      }),
    };
  },
  mounted: function () {
    this.config = getFileConfig(this.externalTable);
  },
  computed: {
    headers: function () {
      return [
        createTableHeader("name"),
        createTableHeader("mail", { mw: 30 }),
        createTableHeader("options", { text: false, mw: 30 }),
      ];
    },
  },
  methods: {
    getFileName: function (item) {
      return item.file_description
        ? item.file_description
        : item.file_name
        ? item.file_name
        : "";
    },
    addFileClick: function (event) {
      this.$router.push({
        ...this.$route,
        query: {
          modal: "file_uploader",
          external_id: this.externalId,
          external_table: this.externalTable,
        },
      });
    },
    onFileDelete: async function (file) {
      // this.$emit("fileDelete", { item: file });
      const { file_id, file_relation_id } = file;
      const confirmationResult = await confirmDelete(
        "File",
        this.getFileName(file)
      );
      if (confirmationResult == "OK") {
        FileService.deleteFile({
          fileId: file_id,
          fileRelatoinId: file_relation_id,
        });
        this.deleteFromFilesState(file);
      }
    },
    deleteFromFilesState: function (file) {
      const files = deleteFileFromArray(this.files, file);
      this.$store.dispatch(getFileAction(this.externalTable), {
        files,
        externalId: this.externalId,
        externalTable: this.externalTable,
      });
    },
    onFileMail: async function (file) {
      // 'mailto:?subject=' + encodeURIComponent(filename) + '&body='+ bodyTxt;
      console.log(file);
      const { data } = await FileService.shortenFileURL({
        file_url: this.getFilePath(file),
      });
      const { shorten_url } = data;
      // sendMail({
      //   subject: file.file_name,
      //   body: shorten_url,
      // });

      sendMailHref({
        subject: file.file_name,
        body: shorten_url,
      });
    },
    getFilePath: function (file) {
      return file.file_link;
      // return file.public == "1"
      //   ? `https://detailss3web.s3.amazonaws.com/files/${clientName}/${file.md}_${file.file_name}`
      //   : `${baseUrl}/${clientName}/files.pl?action=download_document&file_id=${file.file_id}`;
    },
    //MARK: Methods
  },
};
</script>

<style lang="scss" scoped>
.dt-list-item--text {
  // TODO! Change the max-width solution - This is only for 1920px window width. This is not responsive for all window sizes
  max-width: 487.4px;
  flex: 2.2;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  .span {
  }
}
</style>
